export enum FileType {
  /** Обычный файл (документ, изображение и т.д.) */
  FILE = "file",
  /** Видеофайл */
  VIDEO = "video",
}
